import { createAsyncThunk } from "@reduxjs/toolkit";
import { type AxiosResponse } from "axios";
import { awsClientGateway } from "./common/gateway";
import { logMessage } from "../utils/amplifyLogger";
import { clientLog } from "./logging";
import {
  getResourceByLobSelector,
  getInstanceIdSelector,
} from "../selectors/userInstanceSelector";
import type { RootState } from "../store/types";

export const getResources = createAsyncThunk<
  AxiosResponse | unknown,
  void,
  { state: RootState }
>("resources/getResources", async (_arg, { getState, rejectWithValue }) => {
  const state = getState();
  const instanceId = getInstanceIdSelector(state);
  const resourcesByLob = getResourceByLobSelector(state);
  const { ccpAgent: { agentRoutingLob = "" } = {} } = state.ccp;
  try {
    const response = await awsClientGateway({
      pathTemplate: `/resourceInfo/${instanceId}/${agentRoutingLob}`,
      method: "POST",
      body: { resourcesByLob },
    });
    return response;
  } catch (error) {
    clientLog({
      component: `resources`,
      message: `Something went wrong in getResources API => ${error}`,
    });
    logMessage(
      `Resources`,
      `Something went wrong in getResources API => ${error}`,
      `error`,
    );
    return rejectWithValue("Error in getResources api endpoint");
  }
});

export const createResource = createAsyncThunk<
  AxiosResponse | unknown,
  Record<string, unknown>,
  { state: RootState }
>(
  "resources/createResource",
  async (payload, { getState, rejectWithValue }) => {
    const state = getState();
    const instanceId = getInstanceIdSelector(state);
    const { ccpAgent: { agentRoutingLob = "" } = {} } = state.ccp;
    try {
      const response = await awsClientGateway({
        pathTemplate: `/resourceInfo/${instanceId}/${agentRoutingLob}`,
        method: "POST",
        body: payload,
      });
      return response;
    } catch (error) {
      clientLog({
        component: `resources`,
        message: `Something went wrong in createResource API => ${error}`,
      });
      logMessage(
        `Resources`,
        `Something went wrong in createResource API => ${error}`,
        `error`,
      );
      return rejectWithValue(error);
    }
  },
);

export const updateResource = createAsyncThunk<
  AxiosResponse | unknown,
  Record<string, unknown>,
  { state: RootState }
>(
  "resources/updateResource",
  async (payload, { getState, rejectWithValue }) => {
    const state = getState();
    const instanceId = getInstanceIdSelector(state);
    const { ccpAgent: { agentRoutingLob = "" } = {} } = state.ccp;
    try {
      const response = await awsClientGateway({
        pathTemplate: `/resourceInfo/${instanceId}/${agentRoutingLob}`,
        method: "PUT",
        body: payload,
      });
      return response;
    } catch (error) {
      clientLog({
        component: `resources`,
        message: `Something went wrong in updateResource API => ${error}`,
      });
      logMessage(
        `Resources`,
        `Something went wrong in updateResource API => ${error}`,
        `error`,
      );
      return rejectWithValue(error);
    }
  },
);

export const deleteResource = createAsyncThunk<
  AxiosResponse | unknown,
  Record<string, unknown>,
  { state: RootState }
>(
  "resources/deleteResource",
  async (payload, { getState, rejectWithValue }) => {
    const state = getState();
    const instanceId = getInstanceIdSelector(state);
    const { ccpAgent: { agentRoutingLob = "" } = {} } = state.ccp;
    try {
      const response = await awsClientGateway({
        pathTemplate: `/resourceInfo/${instanceId}/${agentRoutingLob}`,
        method: "DELETE",
        body: payload,
      });
      return response;
    } catch (error) {
      clientLog({
        component: `resources`,
        message: `Something went wrong in deleteResource API => ${error}`,
      });
      logMessage(
        `Resources`,
        `Something went wrong in deleteResource API => ${error}`,
        `error`,
      );
      return rejectWithValue(error);
    }
  },
);
